import React, { ReactElement, useState, useEffect } from 'react';
import { NestedLinksButton } from '../NestedLinksButton';
import { SideTabsLink } from '../SideTabsLink';

export interface NestedLinksProps {
  tabs: SideTabsLink[];
  label: string;
}

export function NestedLinks({ tabs, label }: NestedLinksProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const labelToPath = label.replace(/\s+/g, '-').toLowerCase();
    if (window.location.pathname.includes(labelToPath)) setIsOpen(true);
  }, [label]);

  return (
    <li>
      <NestedLinksButton
        handleOnClick={() => setIsOpen(!isOpen)}
        label={label}
        isActive={isOpen}
      />
      <div hidden={!isOpen}>
        <ul className="tabs tabs--vertical hidden-xs hidden-sm">
          {tabs.map((tab) => (
            <SideTabsLink
              key={tab.label}
              pathname={tab.pathname}
              label={tab.label}
              isNested={true}
            />
          ))}
        </ul>
      </div>
    </li>
  );
}
